import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';

import rootReducer from './rootReducer';
import watcherSaga from '../sagas';

// Create the saga middleware
const sagaMiddleware = createSagaMiddleware();

/**
 * Logger middleware for debugging
 */
const loggerMiddleware = store => next => action => {
  console.log('[Redux] Dispatching action:', action.type);
  const result = next(action);
  return result;
};

/**
 * Enable Redux DevTools in development
 */
const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

// Mount it on the Store
const Store = createStore(
  rootReducer, 
  composeEnhancers(
    applyMiddleware(loggerMiddleware, sagaMiddleware)
  )
);

// Then run the saga
const sagaTask = sagaMiddleware.run(watcherSaga);

// Log saga errors
sagaTask.toPromise().catch(err => {
  console.error('[Saga] Root saga error:', err);
});

console.log('[Store] Redux store initialized successfully');

export default Store;
